import { exportReportPdfFromExcelBlob } from "./exportReportPdfFromExcelBlob";

/** Column order matches backend inward Excel export. */
export const INWARD_EXPORT_HEADERS = [
  "Transaction ID",
  "Invoice Number",
  "Posting Date",
  "Company",
  "Customer SKU Code",
  "Product Name",
  "Invoice Qty",
  "Received Qty",
  "Batch Number",
  "Mfg Date",
  "Expiry Date",
  "Batch Qty",
  "Dock In Time",
  "Dock Out Time",
  "Vehicle Reporting Date",
  "Vehicle",
  "Vehicle Temperature",
  "Product Temperature",
  "Status",
];

export async function exportInwardReportPdfFromExcelBlob(excelBlob, filename) {
  return exportReportPdfFromExcelBlob(
    excelBlob,
    filename,
    INWARD_EXPORT_HEADERS
  );
}
